@if (movie()) {
  <h1 class="movie-title">{{ movie()?.title }}</h1>
}
